import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles/App.css';
import { AuthProvider } from './context/AuthContext';


// Pages
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Directory from './pages/Directory';
import Profile from './pages/Profile';
import ProfileSettings from './pages/ProfileSettings';
import NotFound from './pages/NotFound';
import VerifyEmail from './pages/VerifyEmail';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';

// Pages d'administration
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminUsers from './pages/admin/AdminUsers';
import ProfileApproval from './pages/admin/ProfileApproval';
import ProfileDetails from './pages/admin/ProfileDetails';
import ExpertiseManagement from './pages/admin/ExpertiseManagement';
import NetworkManagement from './pages/admin/NetworkManagement';
import OrganizationManagement from './pages/admin/OrganizationManagement';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
import AdminRoute from './components/AdminRoute';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="app">
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/directory" element={<Directory />} />
            <Route path="/profile/settings" element={<ProfileSettings />} />
            <Route path="/profile/:id" element={<Profile />} />
            <Route path="/verify-email/:token" element={<VerifyEmail />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            
            {/* Routes d'administration protégées */}
            <Route element={<AdminRoute />}>
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/users" element={<AdminUsers />} />
              <Route path="/admin/profiles" element={<ProfileApproval />} />
              <Route path="/admin/profiles/:profileId" element={<ProfileDetails />} />
              <Route path="/admin/users/:userId/profile" element={<ProfileDetails />} />
              <Route path="/admin/expertises" element={<ExpertiseManagement />} />
              <Route path="/admin/networks" element={<NetworkManagement />} />
              <Route path="/admin/organizations" element={<OrganizationManagement />} />
            </Route>
            
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
